// API Configuration
// Production configuration for FamaLink deployment
const PRODUCTION_API_URL = 'https://back.famalink.app/api/v1';
const PRODUCTION_WEBSOCKET_URL = 'wss://back.famalink.app';

// Development configuration
const HOST_IP = 'localhost';
const API_PORT = '3000';

// Use development URL for local development, production for build
const isDevelopment = import.meta.env.DEV;
const BASE_URL = isDevelopment ? `http://${HOST_IP}:${API_PORT}/api/v1` : PRODUCTION_API_URL;
const WS_URL = isDevelopment ? `ws://${HOST_IP}:${API_PORT}` : PRODUCTION_WEBSOCKET_URL;

export const API_CONFIG = {
  HOST_IP,
  API_PORT,
  BASE_URL,
  WEBSOCKET_URL: WS_URL,
};

// Export individual values for backward compatibility
export const API_BASE_URL = API_CONFIG.BASE_URL;
export const WEBSOCKET_URL = API_CONFIG.WEBSOCKET_URL;
